'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _imageDetail = require('./imageDetail.component');

var _imageDetail2 = _interopRequireDefault(_imageDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageDetailModule = _angular2.default.module('imageDetail', [_angularUiRouter2.default])

// .config(($stateProvider) => {
//   "ngInject";
//   $stateProvider
//   .state('imageDetail', {
//     url: '/imageDetail',
//     component: 'imageDetail'
//   });
// })

.component('imageDetail', _imageDetail2.default).name;

exports.default = imageDetailModule;


// WEBPACK FOOTER //
// ./client/app/common/imageDetail/imageDetail.js